import {gql} from 'apollo-angular';
export const GET_GAME_TIME_PLAYED = gql`
  query getGameTimePlayed($classCode: String!) {
    schoolClassTimePlayed(classCode: $classCode)
  }
`;
